(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('BackgroundDetailController', BackgroundDetailController);

        BackgroundDetailController.$inject = ['$timeout', "$q", '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Backgrounds',
            'MessageService','ThemeClassify','$http','$uibModal'];

    function BackgroundDetailController ($timeout, $q, $scope, $stateParams, $uibModalInstance, entity, Backgrounds,
        MessageService,ThemeClassify, $http,$uibModal) {

        var vm = this;
        vm.data = entity;
        vm.save = save;
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[{key:"type",value:"BACKGROUND", op:"="},{key:"used",value:"true", op:"="}]});

        $scope.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        }

        function save (){
            Backgrounds.update(vm.data, function(res){
                MessageService.success("保存成功");
                $uibModalInstance.close(res);
            }, function(ers){
                MessageService.error("保存失败,请稍后再试");
                $uibModalInstance.dismiss('cancel');
            })
        }
    }
})();
